import axios from 'axios';

export default {

    get(context, endpoint){ 
        return new Promise((resolve,reject)=>{
            axios.get(endpoint)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                console.log('error', error); 
                reject(error)
            })
        });
    },

    post(context , data){
        // console.log(context);
        return new Promise((resolve,reject)=>{
            axios.post(data.endpoint , data.details,{
                onUploadProgress: function( progressEvent ) {
                    context.state.requestStatus.perc = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                    // console.log(pro);
                  }.bind(this)
            })
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                reject(error)
            })
        });
    },

    put(context , data){
        return new Promise((resolve,reject)=>{
            axios.put(data.endpoint , data.details)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                reject(error)
            })
        });
    },

    delete(context , endpoint){
        return new Promise((resolve,reject)=>{
            axios.delete(endpoint)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                reject(error)
            })
        });
    },




    // get(context, endpoint, data){
    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+endpoint+'?token='+context.state.token, data)
    //         .then((data)=>{
    //             resolve(data)
    //         })
    //         .catch((error)=>{
    //             reject(error)
    //         })
    //     });
    // },

    getBranches(context){

        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'branches?token='+context.state.token).then(data=>{
                // console.log(data);
                resolve(data);
            }).catch(error=>{
                reject(error);
                // console.log(error);
            });
        });
    },
 
    getUser(context , id){
        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'users/'+id+'?token='+context.state.token ).then(data=>{
                // console.log(data);
                resolve(data);
            }).catch(error=>{
                reject(error);
                // console.log(error);
            });
        });
    },

    storeUser(context, data){
        return new Promise((resolve,reject)=>{
            axios.post(context.state.endpoint+'users?token='+context.state.token, data)
            .then(resp=>{
                resolve(resp);
            })
            .catch(error=>{
                // context.dispatch('checkIfSessionExpired',error);
                reject(error);
            })
        });
    },

    updateUser(context, data){
        return new Promise((resolve,reject)=>{
            axios.put(context.state.endpoint+'users/'+data['id']+'?token='+context.state.token, data)
            .then(resp=>{
                resolve(resp);
            })
            .catch(error=>{
                // context.dispatch('checkIfSessionExpired',error);
                reject(error);
            })
        });
    },

    deleteUser(context, data){
        return new Promise((resolve,reject)=>{
            axios.delete(context.state.endpoint+'users/'+data['id']+'?token='+context.state.token)
            .then(resp=>{
                resolve(resp);
            })
            .catch(error=>{
                // context.dispatch('checkIfSessionExpired',error);
                reject(error);
            })
        });
    },

    getMessagetypes(context){

        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'messagetypes?token='+context.state.token).then(data=>{
                // console.log(data);
                resolve(data);
            }).catch(error=>{
                reject(error);
                // console.log(error);
            });
        });
    },

    getMessages(context){

        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'messages?token='+context.state.token).then(data=>{
                // console.log(data);
                resolve(data);
            }).catch(error=>{
                reject(error);
                // console.log(error);
            });
        });
    },

    storeMessage(context, data){
        return new Promise((resolve,reject)=>{
            axios.post(context.state.endpoint+'messages?token='+context.state.token, data)
            .then(resp=>{
                // console.log(resp);
                resolve(resp);
            })
            .catch(error=>{
                
                // context.dispatch('checkIfSessionExpired',error);
                reject(error);
            })
        });
    },

    updateMessage (context ,payload){  
        return new Promise((resolve,reject)=>{
            //i changed this endpoint because a put request can't carry a formdata payload
            axios.post(context.state.endpoint+'messages/updatemessage/'+payload[0]['id']+'?token='+context.state.token, payload[1] , /*{ headers: {'Content-Type': 'application/x-www-form-urlencoded'} }*/)
            .then(resp=>{
                // console.log(resp);
                resolve(resp);
            })
            .catch(function(error){
                // console.log(JSON.parse(error.request.response));
                if(error.request.status == 401 || error.request.status == 400){
                    // context.dispatch('checkIfSessionExpired',error);
                }else{
                    reject(error);
                }
            })
        });
    },

    deleteMessage(context, data){
        return new Promise((resolve,reject)=>{
            axios.delete(context.state.endpoint+'messages/'+data['id']+'?token='+context.state.token)
            .then(resp=>{
                resolve(resp);
            })
            .catch(error=>{
                // context.dispatch('checkIfSessionExpired',error);
                reject(error);
            })
        });
    },

    getMessagesBranch(context, data){
        let id  = data['id'];
        let num = data['page'];
        
        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'messages/branch/'+id+'?page='+num+'&token='+context.state.token).then(data=>{
                console.log(data); 
                resolve(data);
            }).catch(error=>{
                // context.dispatch('checkIfSessionExpired',error);
                reject(error);
                // console.log(error);
            });
        });
    },

    searchMessages(context, data){

        return new Promise((resolve,reject)=>{
            axios.post(context.state.endpoint+'messages/search?token='+context.state.token , data ).then(
                (resp)=>{
                    resolve(resp);
                }
            ).catch(
                (resp)=>{
                    reject(resp);
                }
            );
        });
    },
 

    getUsers(context){
        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'users?token='+context.state.token)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                reject(error)
            })
        });
    },

    getRoles(context){
        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'roles?token='+context.state.token)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                reject(error)
            })
        });
    },

    getRole(context , id){
        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'roles/'+id+'?token='+context.state.token ).then(data=>{
                resolve(data);
            }).catch(error=>{
                reject(error);
            });
        });
    },

    getPermissions(context){
        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'permissions?token='+context.state.token)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                reject(error)
            })
        });
    },

    getPermission(context , id){
        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'permissions/'+id+'?token='+context.state.token ).then(data=>{
                // console.log(data);
                resolve(data);
            }).catch(error=>{
                reject(error);
                // console.log(error);
            });
        });
    },
    
    // signin(context,data){

    //     return new Promise((resolve,reject)=>{
    //     axios.post(context.state.endpoint+'login',data)
    //         .then(resp=>{
    //             // console.log(resp);
    //             resolve(resp);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         })
    //     });
    // },
    checkAuth(context){
        return new Promise((resolve,reject)=>{
            axios.get(context.state.endpoint+'checkAuth?token='+context.state.token)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                // localStorage.removeItem('token');
                reject(error)
            })
        });
    },

    // getSideMenus(context,api){
    //     // window.console.log(api);
    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+api+'?token='+context.state.token)
    //         .then((data)=>{
    //             resolve(data);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         });
    //     });
    // },
    checkIfSessionExpired(context , error){
        try{
            if(error.request.status == 401 || error.request.status == 400 || error.request.status == 404){
                  //token expired
                //   this.$store.commit('logout');
                //   alert("Your session has expired");
                    // window.location='/';
                    context.dispatch('relogin',context); 
              }
              else if(JSON.parse(error.request.response).message == "Token has expired"){
                  //token expired
                //   this.$store.commit('logout');
                //   alert("Your session has expired"); 
                    // window.location='/';
                    context.dispatch('relogin',context); 
              }
          }
          catch(e){
            //   
            context.dispatch('relogin',context); 
            context.commit('logout');
          }
    }, 
    relogin(context){ 
        var password = prompt("Your session has expired \n Enter your password");
        var user=JSON.parse(localStorage.getItem('user'));

        if(password != null){ 
          context.dispatch('post',{endpoint:this.$store.state.endpoint+'login',details:{email:user.email,password}} )
            .then(data=>{
                window.console.log(data);
                // this.login_task.btntext="Redirecting...";

                context.commit('setUser',data.data.user);
                context.commit('setToken',data.data.token);

                location.reload();
                
                // window.location="/";

            })
            .catch(error=>{
            console.log(error);
                context.commit('logout');
                window.location='/login';
            });
        }else{
          context.commit('logout');
          window.location='/login';
        }
    },
    register(context,data){

        return new Promise((resolve,reject)=>{
            axios.post(context.state.endpoint+'users',data).then(data=>{
                resolve(data);
            }).catch(error=>{
                reject(error);
            });
        });

    },

    // getCommittees(context){

    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'committees?token='+context.state.token).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });

    // },

    // getItemTypes(context){

    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'itemtypes?token='+context.state.token).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });

    // },

    // getNewsItem(context){

    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'newsitems?token='+context.state.token).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });

    // },

    // sendEmail(context,data){
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'send-mail?token='+context.state.token , data).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });
    // },

    // getUserStatus(context , id){
    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'users/'+id+'?token='+context.state.token ).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });
    // },

    // getItem(context , id){
    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'items/'+id+'?token='+context.state.token ).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });
    // },
    // updateItem(context,data){ 
    //     return new Promise((resolve,reject)=>{
    //         axios.put(context.state.endpoint+'items/'+data.id+'?token='+context.state.token , data ).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });
    // },

    // createNewsItem(context,data){
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'newsitems/?token='+context.state.token , data ).then(
    //             (resp)=>{
    //                 resolve(resp);
    //             }
    //         ).catch(
    //             (resp)=>{
    //                 reject(resp);
    //             }
    //         );
    //     });
    // },
    // updateNewsItem(context,data){
    //     return new Promise((resolve,reject)=>{
    //         axios.put(context.state.endpoint+'newsitems/'+data.id+'/?token='+context.state.token , data ).then(
    //             (resp)=>{
    //                 resolve(resp);
    //             }
    //         ).catch(
    //             (resp)=>{
    //                 reject(resp);
    //             }
    //         );
    //     });
    // },
    // getSingleNewsItem(context,id){ 
    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'newsitems/'+id+'/?token='+context.state.token).then(
    //             (resp)=>{
    //                 resolve(resp);
    //             }
    //         ).catch(
    //             (resp)=>{
    //                 reject(resp);
    //             }
    //         );
    //     });
    // },
    // getItemGroup(context , id){
    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'itemgroups/'+id+'?token='+context.state.token ).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });
    // },
    // getItemGroups(context){
    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'itemgroups/?token='+context.state.token ).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });
    // },
    // updateItemGroup(context,data){
    //     window.console.log(data);
    //     return new Promise((resolve,reject)=>{
    //         axios.put(context.state.endpoint+'itemgroups/'+data.id+'/?token='+context.state.token , data ).then(
    //             (resp)=>{
    //                 resolve(resp);
    //             }
    //         ).catch(
    //             (resp)=>{
    //                 reject(resp);
    //             }
    //         );
    //     });
    // },

    // getLoginLogs(context, data){
    //     let num = data['page'];
        
    //     return new Promise((resolve,reject)=>{
    //         axios.get(context.state.endpoint+'loginlogs?page='+num+'&token='+context.state.token).then(data=>{
    //             // console.log(data);
    //             resolve(data);
    //         }).catch(error=>{
    //             reject(error);
    //             // console.log(error);
    //         });
    //     });
    // },
    
    // addNewRole(context, data){
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'roles?token='+context.state.token, data)
    //         .then(resp=>{
    //             resolve(resp);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         })
    //     });
    // },

    // addPermissionToRole(context, data){
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'addPermissionToRole?token='+context.state.token,data)
    //         .then(resp=>{
    //             resolve(resp);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         })
    //     });
    
    // },

    // removePermissionFromRole(context, data){
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'removePermissionFromRole?token='+context.state.token,data)
    //         .then(resp=>{
    //             resolve(resp);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         })
    //     });
    
    // },

    // addUserToRole(context, data){
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'addUserToRole?token='+context.state.token,data)
    //         .then(resp=>{
    //             resolve(resp);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         })
    //     });
    
    // },

    // removeUserFromRole(context, data){
    //     console.log('data', data);
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'removeUserFromRole?token='+context.state.token,data)
    //         .then(resp=>{
    //             resolve(resp);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         })
    //     });
    
    // },

    // addMessagetypeToRole(context, data){
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'addMessagetypeToRole?token='+context.state.token,data)
    //         .then(resp=>{
    //             resolve(resp);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         })
    //     });
    
    // },

    // removeMessagetypeFromRole(context, data){
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'removeMessagetypeFromRole?token='+context.state.token,data)
    //         .then(resp=>{
    //             resolve(resp);
    //         })
    //         .catch(error=>{
    //             // context.dispatch('checkIfSessionExpired',error);
    //             reject(error);
    //         })
    //     });
    
    // },

    // updateProfileImage(context,data){ 
        
    //     return new Promise((resolve,reject)=>{
    //         axios.post(context.state.endpoint+'users/profile-image/'+data.id+'/?token='+context.state.token , data.form ).then(
    //             (resp)=>{
    //                 resolve(resp);
    //             }
    //         ).catch(
    //             (resp)=>{
    //                 reject(resp);
    //             }
    //         );
    //     });
    // },
    
    // updateProfile(context,data){ 
        
    //     return new Promise((resolve,reject)=>{
    //         axios.put(context.state.endpoint+'users/'+data.id+'/?token='+context.state.token , data.form ).then(
    //             (resp)=>{
    //                 resolve(resp);
    //             }
    //         ).catch(
    //             (resp)=>{
    //                 reject(resp);
    //             }
    //         );
    //     });
    // },
}